( function () {
	'use strict';

	function loadImage( image ) {
		[ 'src', 'srcset', 'sizes' ].forEach( function ( attribute ) {
			var value = image.dataset[ attribute ];
			if ( value ) {
				image.setAttribute( attribute, value );
				delete image.dataset[ attribute ];
			}
		} );
	}

	function initialiseGallery( gallery ) {
		if ( gallery.dataset.galleryReady ) {
			return;
		}
		gallery.dataset.galleryReady = 'true';
		var slides = Array.from( gallery.querySelectorAll( '[data-catalog-gallery-slide]' ) );
		var viewport = gallery.querySelector( '[data-catalog-gallery-viewport]' );
		var status = gallery.querySelector( '[data-catalog-gallery-status]' );
		var thumbnails = Array.from( gallery.querySelectorAll( '[data-catalog-gallery-thumbnail]' ) );
		var previousButton = gallery.querySelector( '[data-catalog-gallery-previous]' );
		var nextButton = gallery.querySelector( '[data-catalog-gallery-next]' );
		var current = 0;
		var startX = 0;
		var startY = 0;

		if ( slides.length < 2 ) {
			return;
		}

		function show( index ) {
			current = ( index + slides.length ) % slides.length;
			loadImage( slides[ current ].querySelector( 'img' ) );
			slides.forEach( function ( slide, slideIndex ) {
				slide.hidden = slideIndex !== current;
			} );
			thumbnails.forEach( function ( thumbnail, thumbnailIndex ) {
				thumbnail.setAttribute( 'aria-current', thumbnailIndex === current ? 'true' : 'false' );
			} );
			status.textContent = status.dataset.label.replace( '%1$d', current + 1 ).replace( '%2$d', slides.length );
		}

		if ( previousButton ) {
			previousButton.addEventListener( 'click', function () { show( current - 1 ); } );
		}
		if ( nextButton ) {
			nextButton.addEventListener( 'click', function () { show( current + 1 ); } );
		}
		thumbnails.forEach( function ( thumbnail ) {
			thumbnail.addEventListener( 'click', function () {
				show( Number.parseInt( thumbnail.dataset.catalogGalleryThumbnail, 10 ) );
			} );
		} );
		viewport.addEventListener( 'touchstart', function ( event ) {
			startX = event.changedTouches[0].clientX;
			startY = event.changedTouches[0].clientY;
		}, { passive: true } );
		viewport.addEventListener( 'touchend', function ( event ) {
			var deltaX = event.changedTouches[0].clientX - startX;
			var deltaY = event.changedTouches[0].clientY - startY;
			if ( Math.abs( deltaX ) > 40 && Math.abs( deltaX ) > Math.abs( deltaY ) ) {
				show( current + ( deltaX < 0 ? 1 : -1 ) );
			}
		}, { passive: true } );
		gallery.addEventListener( 'keydown', function ( event ) {
			if ( 'ArrowLeft' === event.key || 'ArrowRight' === event.key ) {
				event.preventDefault();
				show( current + ( 'ArrowRight' === event.key ? 1 : -1 ) );
			}
		} );
	}

	document.querySelectorAll( '[data-catalog-gallery]' ).forEach( initialiseGallery );
	// Product details dialogs on listings are fetched after page load.
	document.addEventListener( 'folis:modal-open', function ( event ) {
		event.detail.modal.querySelectorAll( '[data-catalog-gallery]' ).forEach( function ( gallery ) {
			initialiseGallery( gallery );
			gallery.querySelectorAll( 'img[data-src]' ).forEach( loadImage );
		} );
	} );
	window.addEventListener( 'load', function () {
		var loadDeferredImages = function () {
			document.querySelectorAll( '[data-catalog-gallery] img[data-src]' ).forEach( loadImage );
		};
		if ( 'requestIdleCallback' in window ) {
			window.requestIdleCallback( loadDeferredImages );
		} else {
			window.setTimeout( loadDeferredImages, 1 );
		}
	} );
}() );
